export const getParentWidget = (widgetId, allWidgets) => {
    const widget = allWidgets.find((wid) => wid.id === widgetId);
    if (widget) {
        const parentWidget = allWidgets.find((wid) => wid.id === widget.parent);
        return parentWidget;
    }
};
export const isOneParentSupervisor = (widgetId, allWidgets) => {
    const widget = allWidgets.find((wid) => wid.id === widgetId);
    if (widget) {
        const parentWidget = allWidgets.find((wid) => wid.id === widget.parent);
        if (parentWidget === null || parentWidget === void 0 ? void 0 : parentWidget.rel_dashboardWidgetInst.isSupervisor) {
            return true;
        }
        if (parentWidget) {
            return isOneParentSupervisor(parentWidget.id, allWidgets);
        }
    }
    return false;
};
export const getWidgetConfigRecursively = (widget, widgets) => {
    const getConfigKeyRecursively = (widget, key) => {
        if (widget.config.hasOwnProperty(key)) {
            return widget.config[key];
        }
        const widgetParent = widgets.find((wid) => wid.id === widget.parent);
        return getConfigKeyRecursively(widgetParent, key);
    };
    const [assetType, steps] = ['assetType', 'steps'].map((key) => {
        return getConfigKeyRecursively(widget, key);
    });
    return { assetType, steps };
};
export const getWidgetChildsRecursively = (widget, allWidgets) => {
    const widgetHasChild = allWidgets.some((wid) => wid.parent === widget.id);
    if (widgetHasChild) {
        const childs = allWidgets.filter((wid) => wid.parent === widget.id);
        const recursiveChilds = childs.flatMap((child) => getWidgetChildsRecursively(child, allWidgets)).filter((_) => _);
        return [...childs, ...recursiveChilds];
    }
    return [];
};
